// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/home/user/upos-dev/app/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "path": "/user",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__UserLayout' */'/home/user/upos-dev/app/src/layouts/UserLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "name": "login",
        "path": "/user/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Session__Login' */'/home/user/upos-dev/app/src/pages/Session/Login'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__SecurityLayout' */'/home/user/upos-dev/app/src/layouts/SecurityLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'/home/user/upos-dev/app/src/layouts/BasicLayout'), loading: LoadingComponent}),
        "routes": [
          {
            "path": "/",
            "redirect": "/dashboard",
            "exact": true
          },
          {
            "name": "dashboard",
            "path": "/dashboard",
            "icon": "dashboard",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Dashboard' */'/home/user/upos-dev/app/src/pages/Dashboard'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "sales-operations",
            "path": "/sales-operations",
            "divider": {},
            "exact": true
          },
          {
            "name": "product-catalogue",
            "icon": "appstore",
            "path": "/product-catalogue",
            "authority": "menu_management:access",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ProductCatalogue' */'/home/user/upos-dev/app/src/pages/ProductCatalogue'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "name": "menu-management",
            "icon": "database",
            "path": "/menu",
            "authority": "menu_management:access",
            "routes": [
              {
                "name": "menu-management",
                "path": "/menu/item",
                "exact": true,
                "hideInMenu": false,
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MenuManagement__Main' */'/home/user/upos-dev/app/src/pages/MenuManagement/Main'), loading: LoadingComponent})
              },
              {
                "name": "menu-item",
                "path": "/menu/item/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MenuManagement__NewMenuItem' */'/home/user/upos-dev/app/src/pages/MenuManagement/NewMenuItem'), loading: LoadingComponent}),
                "exact": true,
                "hideInMenu": true
              },
              {
                "name": "menu-reorder",
                "path": "/menu/reorder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MenuManagement__Reorder' */'/home/user/upos-dev/app/src/pages/MenuManagement/Reorder'), loading: LoadingComponent}),
                "exact": true,
                "hideInMenu": true
              },
              {
                "name": "options-reorder",
                "path": "/menu/options/reorder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MenuManagement__OptionGroup__Reorder' */'/home/user/upos-dev/app/src/pages/MenuManagement/OptionGroup/Reorder'), loading: LoadingComponent}),
                "exact": true,
                "hideInMenu": true
              },
              {
                "name": "menu-status",
                "icon": "database",
                "path": "/menu/status",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MenuStatus' */'/home/user/upos-dev/app/src/pages/MenuStatus'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "menu-bulk-edit",
                "icon": "database",
                "path": "/menu/bulk-edit",
                "authority": "menu_item:write",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MenuBulkEdit' */'/home/user/upos-dev/app/src/pages/MenuBulkEdit'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "promotions",
            "icon": "MoneyCollect",
            "path": "/promotions",
            "authority": "promotions:read",
            "routes": [
              {
                "name": "globals",
                "path": "/promotions/globals",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BasicGlobalBrandOutlet__BasicGlobal' */'/home/user/upos-dev/app/src/pages/BasicGlobalBrandOutlet/BasicGlobal'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "brand-outlet",
                "path": "/promotions/specifics",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BasicGlobalBrandOutlet__BasicBrandOutlet' */'/home/user/upos-dev/app/src/pages/BasicGlobalBrandOutlet/BasicBrandOutlet'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "pos-discounts",
            "icon": "barcode",
            "path": "/posdiscounts",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PosDiscounts' */'/home/user/upos-dev/app/src/pages/PosDiscounts'), loading: LoadingComponent}),
            "authority": "pos_discount:read",
            "exact": true
          },
          {
            "name": "payment-types",
            "icon": "CreditCard",
            "path": "/payment",
            "authority": "payment_type:read",
            "routes": [
              {
                "name": "globals",
                "icon": "book",
                "path": "/payment/globals",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PaymentTypes__Globals' */'/home/user/upos-dev/app/src/pages/PaymentTypes/Globals'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "brand-outlet",
                "icon": "book",
                "path": "/payment/specifics",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PaymentTypes__PaymentType' */'/home/user/upos-dev/app/src/pages/PaymentTypes/PaymentType'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "payment-reorder",
                "path": "/payment/reorder",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__PaymentTypes__Reorder' */'/home/user/upos-dev/app/src/pages/PaymentTypes/Reorder'), loading: LoadingComponent}),
                "exact": true,
                "hideInMenu": true
              }
            ]
          },
          {
            "name": "support-operations",
            "path": "/support-operations",
            "divider": {},
            "exact": true
          },
          {
            "name": "digital-signage",
            "icon": "desktop",
            "path": "/signage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DigitalSignage' */'/home/user/upos-dev/app/src/pages/DigitalSignage'), loading: LoadingComponent}),
            "authority": [
              "signage:read",
              "signage:write"
            ],
            "exact": true
          },
          {
            "name": "inventory-operations",
            "path": "/inventory-operations",
            "divider": {},
            "exact": true
          },
          {
            "name": "Inventory",
            "icon": "book",
            "path": "/inventory",
            "authority": "inventory:read",
            "routes": [
              {
                "name": "Catalogue",
                "icon": "book",
                "path": "/inventory/catalogue",
                "routes": [
                  {
                    "name": "Brand",
                    "path": "/inventory/catalogue/catalogue",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Inventory__Catalogue' */'/home/user/upos-dev/app/src/pages/Inventory/Catalogue'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "Global",
                    "path": "/inventory/catalogue/global",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Inventory__Catalogue__Globals' */'/home/user/upos-dev/app/src/pages/Inventory/Catalogue/Globals'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "name": "Process Incoming-Stock",
                "path": "/inventory/instocking",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Inventory__InStocking' */'/home/user/upos-dev/app/src/pages/Inventory/InStocking'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "Stocks",
                "path": "/inventory/stocks",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Inventory__Stocks' */'/home/user/upos-dev/app/src/pages/Inventory/Stocks'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "master-stock-list",
                "path": "/inventory/stocks/admin",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Inventory__StockAdmin' */'/home/user/upos-dev/app/src/pages/Inventory/StockAdmin'), loading: LoadingComponent}),
                "authority": [
                  "inventory_stock:admin"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "finance",
            "path": "/finance",
            "divider": {},
            "exact": true
          },
          {
            "name": "Sales",
            "icon": "dollar",
            "path": "/salesdata",
            "authority": [
              "sales:browse_receipts",
              "sales:browse_collections"
            ],
            "routes": [
              {
                "name": "Transactions",
                "path": "/salesdata/transactions",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SalesData__Transactions' */'/home/user/upos-dev/app/src/pages/SalesData/Transactions'), loading: LoadingComponent}),
                "authority": "sales:browse_receipts",
                "exact": true
              },
              {
                "name": "Settlements",
                "path": "/salesdata/settlements",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SalesData__Settlements' */'/home/user/upos-dev/app/src/pages/SalesData/Settlements'), loading: LoadingComponent}),
                "authority": "sales:browse_collections",
                "exact": true
              }
            ]
          },
          {
            "name": "Reports",
            "icon": "file",
            "path": "/biz-reports",
            "authority": [
              "report:exportdata",
              "report:zreport",
              "report:inventorymovement"
            ],
            "routes": [
              {
                "name": "Z-Reports",
                "path": "/biz-reports/zreports",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BizReports__Z-Reports' */'/home/user/upos-dev/app/src/pages/BizReports/Z-Reports'), loading: LoadingComponent}),
                "authority": "report:zreport",
                "exact": true
              },
              {
                "name": "Export Raw Data",
                "path": "/biz-reports/rawdata",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BizReports__RawData' */'/home/user/upos-dev/app/src/pages/BizReports/RawData'), loading: LoadingComponent}),
                "authority": "report:exportdata",
                "exact": true
              },
              {
                "name": "Inventory Movement",
                "path": "/biz-reports/invMovement",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__BizReports__InventoryMovement' */'/home/user/upos-dev/app/src/pages/BizReports/InventoryMovement'), loading: LoadingComponent}),
                "authority": "report:inventorymovement",
                "exact": true
              }
            ]
          },
          {
            "name": "integration",
            "path": "/integration",
            "divider": {},
            "exact": true
          },
          {
            "name": "Xero",
            "icon": "export",
            "path": "/xero",
            "authority": "xero:read",
            "routes": [
              {
                "name": "invoices",
                "path": "/xero/invoices",
                "routes": [
                  {
                    "name": "all-invoices",
                    "path": "/xero/invoices/all",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Xero__Invoices' */'/home/user/upos-dev/app/src/pages/Xero/Invoices'), loading: LoadingComponent}),
                    "authority": [
                      "xero:read"
                    ],
                    "exact": true
                  },
                  {
                    "name": "working-invoices",
                    "path": "/xero/invoices/working",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Xero__Invoices__Working' */'/home/user/upos-dev/app/src/pages/Xero/Invoices/Working'), loading: LoadingComponent}),
                    "authority": [
                      "xero:read"
                    ],
                    "exact": true
                  },
                  {
                    "name": "unposted-invoices",
                    "path": "/xero/invoices/unposted",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Xero__Invoices__Unposted' */'/home/user/upos-dev/app/src/pages/Xero/Invoices/Unposted'), loading: LoadingComponent}),
                    "authority": [
                      "xero:post"
                    ],
                    "exact": true
                  },
                  {
                    "name": "view-invoice",
                    "path": "/xero/invoices/view/:id",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Xero__Invoices__View' */'/home/user/upos-dev/app/src/pages/Xero/Invoices/View'), loading: LoadingComponent}),
                    "hideInMenu": true,
                    "authority": [
                      "xero:read"
                    ],
                    "exact": true
                  }
                ]
              },
              {
                "name": "mapping",
                "path": "/xero/mapping",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Xero__Mapping' */'/home/user/upos-dev/app/src/pages/Xero/Mapping'), loading: LoadingComponent}),
                "authority": [
                  "xero:write"
                ],
                "exact": true
              },
              {
                "name": "invoice-config",
                "path": "/xero/invoice-config",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Xero__InvoiceConfig' */'/home/user/upos-dev/app/src/pages/Xero/InvoiceConfig'), loading: LoadingComponent}),
                "authority": [
                  "xero:read"
                ],
                "exact": true
              },
              {
                "name": "callback",
                "path": "/xero/callback",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Xero__Callback' */'/home/user/upos-dev/app/src/pages/Xero/Callback'), loading: LoadingComponent}),
                "hideInMenu": true,
                "exact": true
              }
            ]
          },
          {
            "name": "MallUpload",
            "icon": "CloudUpload",
            "path": "/mall-upload",
            "authority": "mall_upload:read",
            "routes": [
              {
                "name": "file",
                "path": "/mall-upload/file",
                "routes": [
                  {
                    "name": "all-files",
                    "path": "/mall-upload/file/all",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MallUpload__File' */'/home/user/upos-dev/app/src/pages/MallUpload/File'), loading: LoadingComponent}),
                    "authority": [
                      "mall_upload:read"
                    ],
                    "exact": true
                  },
                  {
                    "name": "unposted-files",
                    "path": "/mall-upload/file/unposted",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MallUpload__File__Unposted' */'/home/user/upos-dev/app/src/pages/MallUpload/File/Unposted'), loading: LoadingComponent}),
                    "authority": [
                      "mall_upload:post"
                    ],
                    "exact": true
                  }
                ]
              },
              {
                "name": "upload-config",
                "path": "/mall-upload/config",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__MallUpload__Config' */'/home/user/upos-dev/app/src/pages/MallUpload/Config'), loading: LoadingComponent}),
                "authority": [
                  "mall_upload:read"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "delivery-platforms",
            "icon": "car",
            "path": "/delivery-platform",
            "authority": [
              "delivery_config:read",
              "delivery_order:read"
            ],
            "routes": [
              {
                "name": "delivery-config",
                "path": "/delivery-platform/config",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__DeliveryPlatform__Config' */'/home/user/upos-dev/app/src/pages/DeliveryPlatform/Config'), loading: LoadingComponent}),
                "authority": [
                  "delivery_config:read"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "apikey",
            "icon": "KeyOutlined",
            "path": "/api-key",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__ApiKey' */'/home/user/upos-dev/app/src/pages/ApiKey'), loading: LoadingComponent}),
            "authority": "api_key:read",
            "exact": true
          },
          {
            "name": "setup",
            "path": "/setup",
            "divider": {},
            "exact": true
          },
          {
            "name": "organization-structure",
            "icon": "control",
            "path": "/organization",
            "authority": [
              "brand:list",
              "brand:write",
              "outlet:list",
              "outlet:write",
              "terminal:read",
              "terminal:write"
            ],
            "routes": [
              {
                "name": "brands",
                "icon": "database",
                "path": "/organization/brands",
                "authority": [
                  "brand:list",
                  "brand:write"
                ],
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Organization__Brands' */'/home/user/upos-dev/app/src/pages/Organization/Brands'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "outlets",
                "icon": "database",
                "path": "/organization/outlets",
                "authority": [
                  "outlet:list",
                  "outlet:write"
                ],
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Organization__Outlets' */'/home/user/upos-dev/app/src/pages/Organization/Outlets'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "terminals",
                "icon": "database",
                "path": "/organization/terminals",
                "authority": [
                  "terminal:read",
                  "terminal:write"
                ],
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Organization__Terminals' */'/home/user/upos-dev/app/src/pages/Organization/Terminals'), loading: LoadingComponent}),
                "exact": true
              }
            ]
          },
          {
            "name": "user-management",
            "icon": "team",
            "path": "/user-management",
            "authority": [
              "staff:read",
              "staff:write",
              "policygroup:view",
              "policygroup:edit",
              "policygroup:create"
            ],
            "routes": [
              {
                "name": "users",
                "path": "/user-management/users",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__Staff' */'/home/user/upos-dev/app/src/pages/Configuration/Staff'), loading: LoadingComponent}),
                "authority": [
                  "staff:read",
                  "staff:write"
                ],
                "exact": true
              },
              {
                "name": "roles",
                "path": "/user-management/roles",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__PolicyGroup' */'/home/user/upos-dev/app/src/pages/Configuration/PolicyGroup'), loading: LoadingComponent}),
                "authority": [
                  "policygroup:view",
                  "policygroup:edit",
                  "policygroup:create"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "windows-pos",
            "icon": "windows",
            "path": "/windows-pos",
            "authority": [
              "pos_versions:read",
              "pos_versions:write"
            ],
            "routes": [
              {
                "name": "pos-versions",
                "path": "/windows-pos/versions",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__PosVersions' */'/home/user/upos-dev/app/src/pages/Configuration/PosVersions'), loading: LoadingComponent}),
                "authority": [
                  "pos_versions:read",
                  "pos_versions:write"
                ],
                "exact": true
              },
              {
                "name": "language-keys",
                "path": "/windows-pos/languages",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__PosLanguage__Globals' */'/home/user/upos-dev/app/src/pages/Configuration/PosLanguage/Globals'), loading: LoadingComponent}),
                "authority": [
                  "pos_versions:read",
                  "pos_versions:write"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "config",
            "icon": "setting",
            "path": "/config",
            "authority": [
              "sector:read",
              "sector:write",
              "mall:read",
              "mall:write",
              "staff:read",
              "staff:write"
            ],
            "routes": [
              {
                "name": "sectors",
                "icon": "Aim",
                "path": "/config/sector",
                "authority": [
                  "sector:read",
                  "sector:write"
                ],
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__Sectors' */'/home/user/upos-dev/app/src/pages/Configuration/Sectors'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "malls",
                "icon": "Environment",
                "path": "/config/malls",
                "authority": [
                  "mall:read",
                  "mall:write"
                ],
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__Malls' */'/home/user/upos-dev/app/src/pages/Configuration/Malls'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "uom",
                "icon": "idcard",
                "path": "/config/inventoryuom",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__InventoryUOM' */'/home/user/upos-dev/app/src/pages/Configuration/InventoryUOM'), loading: LoadingComponent}),
                "authority": [
                  "inventory_catalog:uom"
                ],
                "exact": true
              },
              {
                "name": "sales-groups",
                "path": "/config/salesgroups",
                "authority": [
                  "sales_group:read",
                  "sales_group:write"
                ],
                "routes": [
                  {
                    "name": "global-sales-groups",
                    "path": "/config/salesgroups/globals",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__SalesGroups__Globals' */'/home/user/upos-dev/app/src/pages/Configuration/SalesGroups/Globals'), loading: LoadingComponent}),
                    "exact": true
                  },
                  {
                    "name": "brand-outlet-sales-groups",
                    "path": "/config/salesgroups/specifics",
                    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__SalesGroups__ByBrandOutlet' */'/home/user/upos-dev/app/src/pages/Configuration/SalesGroups/ByBrandOutlet'), loading: LoadingComponent}),
                    "exact": true
                  }
                ]
              },
              {
                "name": "appsetting",
                "icon": "setting",
                "path": "/config/appsetting",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Configuration__ApplicationSetting' */'/home/user/upos-dev/app/src/pages/Configuration/ApplicationSetting'), loading: LoadingComponent}),
                "authority": [
                  "configuration:read"
                ],
                "exact": true
              }
            ]
          },
          {
            "name": "logs",
            "icon": "book",
            "path": "/logs",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Logs' */'/home/user/upos-dev/app/src/pages/Logs'), loading: LoadingComponent}),
            "authority": [
              "log:read"
            ],
            "exact": true
          },
          {
            "name": "change-password",
            "icon": "Unlock",
            "path": "/account/changepassword",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__Session__ChangePassword' */'/home/user/upos-dev/app/src/pages/Session/ChangePassword'), loading: LoadingComponent}),
            "hideInMenu": true,
            "exact": true
          },
          {
            "name": "Receipt Page",
            "icon": "tool",
            "path": "/transactions/:id",
            "hideInMenu": true,
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__SalesData__ReceiptViewer' */'/home/user/upos-dev/app/src/pages/SalesData/ReceiptViewer'), loading: LoadingComponent}),
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/user/upos-dev/app/src/pages/404'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/user/upos-dev/app/src/pages/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__404' */'/home/user/upos-dev/app/src/pages/404'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
